import React from "react";

const LkDeliveryTop = (props) => {
    return (
        <>
            <div className="flex justify-between">
                <div className="flex flex-col sm:flex-row sm:gap-[32px] sm:items-end">
                    <div>
                        <div className="sm:mt-0 mt-14 text-[14px] sm:mb-[5px]"
                        style={{color: props.data.LkDeliveryTop.TopTexts.text1Color}}>{props.data.LkDeliveryTop.TopTexts.text1}</div>
                        <div className="text-[28px] sm:text-[32px]"
                        style={{color: props.data.LkDeliveryTop.TopTexts.text2Color}}>{props.data.LkDeliveryTop.TopTexts.text2}</div>
                    </div>
                    <div className="flex items-center gap-[8px]">
                        <button
                            onClick={() => props.deliveryFilter(1)}
                            className={`sm:text-[14px] text-[12px] rounded-[43px] flex items-center border-solid border-[1px] p-[9px] pr-[14px] gap-[8px]`}
                            style={{
                                background: props.deliveryFilter1 ? props.data.LkDeliveryTop.deliveryFilterBtns.btnActiveBg : '',
                                color: props.deliveryFilter1 ? props.data.LkDeliveryTop.deliveryFilterBtns.btnActiveColor : '',
                                borderColor: !props.deliveryFilter1 ? props.data.LkDeliveryTop.deliveryFilterBtns.btnBorder : '',
                            }}>
                            <div className={`sm:text-[14px] rounded-full w-[22px] h-[22px] flex items-center justify-center text-[#fff]`}
                                style={{
                                    color: props.deliveryFilter1 ? props.data.LkDeliveryTop.deliveryFilterBtns.btnActiveColor : null,
                                    background: props.deliveryFilter1 ? props.data.LkDeliveryTop.deliveryFilterBtns.btnActiveBg1 : props.data.LkDeliveryTop.deliveryFilterBtns.btnActiveBg
                                }}
                            >{props.activeCount}</div>
                            {props.data.LkDeliveryTop.deliveryFilterBtns.btnText1}
                        </button>
                        <button
                            onClick={() => props.deliveryFilter(2)}
                            className={`sm:text-[14px] text-[12px] border-solid border-[1px] rounded-[43px] flex items-center p-[9px] pr-[14px] gap-[8px]  `}
                            style={{
                                background: props.deliveryFilter2 ? props.data.LkDeliveryTop.deliveryFilterBtns.btnActiveBg : '',
                                color: props.deliveryFilter2 ? props.data.LkDeliveryTop.deliveryFilterBtns.btnActiveColor : '',
                                borderColor: !props.deliveryFilter2 ? props.data.LkDeliveryTop.deliveryFilterBtns.btnBorder : '',
                            }}>
                            <div className={`sm:text-[14px] rounded-full w-[22px] h-[22px] flex items-center justify-center text-[#fff]`}
                            style={{
                                color: props.deliveryFilter2 ? props.data.LkDeliveryTop.deliveryFilterBtns.btnActiveColor : null,
                                background: props.deliveryFilter2 ? props.data.LkDeliveryTop.deliveryFilterBtns.btnActiveBg1 : props.data.LkDeliveryTop.deliveryFilterBtns.btnActiveBg
                            }}>
                                {props.completedCount}
                            </div>
                            {props.data.LkDeliveryTop.deliveryFilterBtns.btnText2}
                        </button>
                    </div>
                </div>
                <div className="md:flex hidden items-center gap-[8px]">
                    <button onClick={() => props.viewFilter(1)} className={`p-[10px] border-solid border-[1px] rounded-[43px]`}
                        style={{
                            borderColor: props.data.LkDeliveryTop.deliveryViewBtns.border,
                            background: props.viewBtn1 ? props.data.LkDeliveryTop.deliveryViewBtns.bgActive : ''
                        }}>
                        <img src={props.viewBtn1 ? props.data.LkDeliveryTop.deliveryViewBtns.btnImage1 : props.data.LkDeliveryTop.deliveryViewBtns.btnImage1Active} />
                    </button>
                    <button onClick={() => props.viewFilter(2)} className={` p-[10px] border-solid border-[1px]  rounded-[43px]`}
                        style={{
                            borderColor: props.data.LkDeliveryTop.deliveryViewBtns.border,
                            background: props.viewBtn2 ? props.data.LkDeliveryTop.deliveryViewBtns.bgActive : ''
                        }}>
                    <img src={props.viewBtn2 ? props.data.LkDeliveryTop.deliveryViewBtns.btnImage2Active  : props.data.LkDeliveryTop.deliveryViewBtns.btnImage2} />
                    </button>
                </div>
            </div>
            {/* ЛИНИИ */}
            <div className="flex justify-between gap-[30px] mt-[16px]">
                <div className="flex-1 border-[4px] border-solid border-b" 
                style={{borderColor: props.data.LkDeliveryTop.LkDeliveryTopLines.color}}></div>
                <div className="flex-1 border-[4px] border-solid border-b" 
                style={{borderColor: props.data.LkDeliveryTop.LkDeliveryTopLines.color}}></div>
                <div className="flex-1 border-[4px] border-solid border-b" 
                style={{borderColor: props.data.LkDeliveryTop.LkDeliveryTopLines.color}}></div>
                <div className="flex-1 border-[4px] border-solid border-b" 
                style={{borderColor: props.data.LkDeliveryTop.LkDeliveryTopLines.color}}></div>
            </div>
        </>
    );
};

export default LkDeliveryTop;
